import {
  Table,
  StatusIndicator,
  Box,
  Button,
  Header,
  Input,
  SpaceBetween,
} from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import { ApiRequestStatus } from 'src/types/ApiRequestStatus';
import { Task } from 'src/types/helios/Task';
import { DateFormats, formatDateTime } from 'src/utils/generalUtils';
import { openTaskDetailsPage } from 'src/helper/taskHelper';

interface TasksTableProps {
  'tasks': Task[];
  'fetchTasksApiStatus'?: ApiRequestStatus;
  'data-testid'?: string;
}

const TasksTable = ({
  tasks,
  fetchTasksApiStatus,
  'data-testid': dataTestId,
}: TasksTableProps) => {
  const navigate = useNavigate();
  const columnDefinitions = [
    {
      id: 'id',
      key: 'id',
      header: 'Task ID',
      cell: (item: Task) => item.taskId,
    },
    {
      id: 'name',
      key: 'name',
      header: 'Task',
      cell: (item: Task) => item.taskName,
    },
    {
      id: 'status',
      key: 'status',
      header: 'Status',
      cell: (item: Task) => item.taskStatus,
    },
    {
      id: 'assignee',
      key: 'assignee',
      header: 'Assignee',
      cell: (item: Task) => item.assigneeLogin,
    },
    {
      id: 'dueDate',
      key: 'dueDate',
      header: 'Due Date',
      cell: (item: Task) =>
        item.dueDate ? formatDateTime(item.dueDate, DateFormats.LONG_DATE) : '-',
    },
    {
      id: 'actions',
      key: 'actions',
      header: 'Actions',
      cell: (item: Task) => (
        <Button onClick={() => openTaskDetailsPage(navigate, item)} variant="link">
          View Details
        </Button>
      ),
    },
  ];

  return (
    <Table
      data-testid={dataTestId}
      columnDefinitions={columnDefinitions}
      items={tasks}
      loading={fetchTasksApiStatus?.isLoading}
      loadingText="Loading Task"
      trackBy="id"
      empty={
        <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
          <SpaceBetween size="m">
            <StatusIndicator type="warning">No Tasks.</StatusIndicator>
          </SpaceBetween>
        </Box>
      }
      header={<Header counter={`(${tasks.length})`}>Generated Tasks</Header>}
    />
  );
};

export default TasksTable;
